/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useState} from "react";
import "components/elements/main/index.scss";
import { Box } from "@mui/material";
import { getURI } from "helpers/utils";
import ButtonComponent from "components/Button";
import UnifiedSwipeTrigger from "components/elements/main/UnifiedSwipeTrigger";

const ShopHeaderNav = (props) => {

    const {
        onCancel, history, shopId, excludeBackOnHome
    } = props;

    const pageRoute = props.location.pathname;
    const pathArray = pageRoute.split("/");

    const [tab, setTab] = React.useState("");

    const selectedTabInitial = () => {

        let link = pathArray && process.env.REACT_APP_TYPE === "USERSITE" ? pathArray[1] : pathArray[3] ? pathArray[3] : "";

        switch (link) {
            case "":
                setTab("home");
                break;
            case "products":
                setTab("products");
                break;
            case "cart":
                setTab("cart");
                break;
            case "me":
                setTab("account");
                break;
            case "orders":
                setTab("orders");
                break;
            default:
                setTab("");
                break;
        }
    }

    React.useEffect(() => {
        selectedTabInitial();
    });

    const handleBack = () => {
        history.goBack();
    };

    const handleHome = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", shopId));
    };

    const handleProducts = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_products", shopId));
    };

    const handleCart = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_cart", shopId));
    };

    const handleOrders = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_orders", shopId));
    };

    const handleAccount = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_account", shopId));
    };

    return (
        <Box mb={2} width="100%" display="flex">
            <Box width="20%" alignItems="left">
                {excludeBackOnHome ? tab !== "home" ? <ButtonComponent
                    sx={{p: 1, minWidth: 'auto'}}
                    type="primary"
                    variant="outlined"
                    name="< Back"
                    size="medium"
                    onClick={onCancel ? onCancel : handleBack}
                /> : null
                    :
                    <ButtonComponent
                        sx={{p: 1, minWidth: 'auto'}}
                        type="primary"
                        variant="outlined"
                        name="< Back"
                        size="medium"
                        onClick={onCancel ? onCancel : handleBack}
                    />}
            </Box>
            <Box width="60%" display="flex" justifyContent="center" alignItems="center" >
                <span style={{ paddingRight: "10px" }}>
                    {tab === "home" ?
                        <ButtonComponent
                            sx={{p: 1, minWidth: 'auto'}}
                            type="primary"
                            variant="contained"
                            name="Home"
                            size="medium"
                            onClick={handleHome}
                        /> :
                        <ButtonComponent
                            sx={{p: 1, minWidth: 'auto'}}
                            type="primary"
                            variant="outlined"
                            name="Home"
                            size="medium"
                            onClick={handleHome}
                        />
                    }
                </span>
                <span style={{ paddingRight: "10px" }}>
                     {tab === "products" ?
                         <ButtonComponent
                             sx={{p: 1, minWidth: 'auto'}}
                             type="primary"
                             variant="contained"
                             name="Products"
                             size="medium"
                             onClick={handleProducts}
                         /> :
                         <ButtonComponent
                             sx={{p: 1, minWidth: 'auto'}}
                             type="primary"
                             variant="outlined"
                             name="Products"
                             size="medium"
                             onClick={handleProducts}
                         />
                     }
                </span>

                <span style={{ paddingRight: "10px" }}>
                    {tab === "cart" ?
                        <ButtonComponent
                            sx={{p: 1, minWidth: 'auto'}}
                            type="primary"
                            variant="contained"
                            name="Cart"
                            size="medium"
                            onClick={handleCart}
                        /> :
                        <ButtonComponent
                            sx={{p: 1, minWidth: 'auto'}}
                            type="primary"
                            variant="outlined"
                            name="Cart"
                            size="medium"
                            onClick={handleCart}
                        />
                    }</span>

                <span style={{ paddingRight: "10px" }}>
                    {tab === "account" ?
                        <ButtonComponent
                            sx={{p: 1, minWidth: 'auto'}}
                            type="primary"
                            variant="contained"
                            name="Account"
                            size="medium"
                            onClick={handleAccount}
                        /> :
                        <ButtonComponent
                            sx={{p: 1, minWidth: 'auto'}}
                            type="primary"
                            variant="outlined"
                            name="Account"
                            size="medium"
                            onClick={handleAccount}
                        />
                    }</span>
            </Box>
            <Box width="20%" alignItems="left">
                <UnifiedSwipeTrigger
                    onLeftSwipeComplete={() => handleBack()}
                />
            </Box>
        </Box>
    );
};

export default ShopHeaderNav;
